export default "__VITE_ASSET__CCBkcgqi__"